import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { debug } from 'console';
import { tr } from 'date-fns/esm/locale';
import moment from 'moment';
import { Appointment } from '../../core/model/v2/appointment/appointment';
import { AppointmentStatus } from '../../core/model/v2/appointment/appointment-status';
import { ProviderCostEstimator } from '../../core/model/v2/appointment/provider-cost-estimator';
import { Treatment } from '../../core/model/v2/practitioner/treatment';
import { Patient } from '../../core/models/patient/patient';
import { AppointmentsService } from '../../core/services/v2/appointments.service';
import { PatientService } from '../../core/services/v2/patient.service';
import { PracticeService } from '../../core/services/v2/practice.service';
import { UserService } from '../../core/services/v2/user.service';
import { UtilsService } from '../../core/services/v2/utils.service';
import { RescheduleAppointmentComponent } from '../../shared/components/reschedule-appointment/reschedule-appointment.component';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-appointments',
  templateUrl: './patient-appointments.component.html',
  styleUrls: ['./patient-appointments.component.scss']
})
export class PatientAppointmentsComponent implements OnInit {
  @Input() patientDetails: Patient;
  patientProfile: Patient;
  patientAppts: Appointment[] = [];
  requestedAppts: Appointment[] = [];
  pendingAppts: Appointment[] = [];
  upcomingAppts: Appointment[] = [];
  pastAppts: Appointment[] = [];
  isParams = false;
  param: number;
  appt: Appointment;
  appointmentSlot: FormControl;
  section: string;
  providerPricing: string;
  treatmentCode: string;
  constructor(
    private patientService: PatientService,
    private practiceService: PracticeService,
    private appointmentService: AppointmentsService,
    private userService: UserService,
    private router: ActivatedRoute,
    public dialog: MatDialog,
    private utils: UtilsService,
    private loaderService: WindowLoaderService,) { }

  ngOnInit() {
    this.providerPricing = null;
    this.router.params.subscribe(
      (params: any) => {
        if (params.id) {
          this.isParams = true;
          this.param = params.id;
        }
      },
      (error) => { console.error(error); }
    );

    if (this.isParams || this.patientDetails != null) {
      this.getPatientDetailsById(this.param ? this.param : this.patientDetails.id);
    } else {
      this.getPatientDetailsByUserId();
    }
  }

  ngOnDestroy(): void { }

  getPatientDetailsById(id) {
    this.loaderService.blockWithLoader(this.patientService.getPatientDetailsById(id)).subscribe(
      (details) => {
        this.patientProfile = null;
        this.patientProfile = details;
        this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
        this.getAppointmentsByPatientId(this.patientProfile.id);
      },
      (error) => { console.error(error); }
    );
  }

  getPatientDetailsByUserId() {
    this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
      (details) => {
        this.patientProfile = null;
        this.patientProfile = details;
        this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
        this.getAppointmentsByPatientId(this.patientProfile.id);
      },
      (error) => { console.error(error); }
    );
  }

  getAppointmentsByPatientId(patientId) {
    this.loaderService.blockWithLoader(this.appointmentService.getAppointmentsByPatientId(patientId)).subscribe(
      (details) => {
        const currentDateTime = new Date();
        const currentDate = moment(new Date()).format("MM/DD/YYYY");
        this.patientAppts = null;
        this.patientAppts = details.appointmentDetails;

        this.patientAppts = this.patientAppts.sort((a, b) => (moment(a.date) < moment(b.date)) ? -1 : 1);
        if (this.patientAppts.length > 0) {
          const upcomingDateAppts = this.patientAppts.filter(appt => appt.startDateTime ? moment(appt.startDateTime).isSameOrAfter(currentDateTime) : moment(appt.date).isSameOrAfter(currentDate));
          if (upcomingDateAppts.length > 0) {
            this.requestedAppts = upcomingDateAppts.filter(x => x.status == AppointmentStatus.PATIENT_AVAILABILITY_SET);
            this.pendingAppts = upcomingDateAppts.filter(x => x.status == AppointmentStatus.PROVIDER_AVAILABILITY_SET || x.status == AppointmentStatus.PATIENT_SELECTED_APPOINTMENTSLOT);
            this.upcomingAppts = upcomingDateAppts.filter(x => x.status == AppointmentStatus.APPOINTMENT_SCHEDULED || x.status == AppointmentStatus.APPOINTMENT_CANCELLED);
            if (this.upcomingAppts && this.upcomingAppts.length > 0) {
              this.upcomingAppts = this.upcomingAppts.sort((a, b) => (a.status === 'APPOINTMENT_CANCELLED') ? 1 : -1);
            }
          }
          this.pastAppts = this.patientAppts.filter(appt => appt.startDateTime ? moment(appt.startDateTime).isBefore(currentDateTime) : moment(appt.date).isBefore(currentDate));;

        }
      },
      (error) => { console.error(error); }
    );

  }

  viewAppt(appt: Appointment, section: string) {
    this.appointmentSlot = new FormControl(null, Validators.required);
    this.appt = appt;
    this.section = section;
    // this.getProviderServiceCost();
    this.getTreatmentsByName();
    document.getElementById("openViewAppt").click();

  }

  selectAppointmentSlotAppt() {
    if (!this.appointmentSlot.valid) {
      this.utils.showMessageSnackBar(`Please select one of the slots shared by the provider.`, true);
      return;
    }
    const selectedSlotId = this.appointmentSlot.value;
    const apptSlotObj = {
      "appointmentId": this.appt.id,
      "status": AppointmentStatus.PATIENT_SELECTED_APPOINTMENTSLOT,
      "slotId": selectedSlotId
    };
    this.loaderService.blockWithLoader(this.appointmentService.updateAppointmentStatus(apptSlotObj)).subscribe(
      (res) => {
        if (res.response.isSuccess) {
          this.getAppointmentsByPatientId(this.patientProfile.id);
          this.utils.showMessageSnackBar(`Appointment request sent to Dr. ${this.appt.practitioner.fullName}!`);
        }
        else {
        }
      },
      (error) => {
        this.utils.showMessageSnackBar(error, true);
        console.error(error);
      }
    );
  }

  openCancelApptPopup(appt: Appointment) {
    this.appt = null;
    const isCancelAllowed = this.IsCancelOrRescheduleAllow(appt, 'cancel');
    if (!isCancelAllowed) {
      return;
    }
    this.appt = appt;
    document.getElementById("cancelApptModal").click();
  }

  IsCancelOrRescheduleAllow(appt: Appointment, event: string) {
    const currentDateTime = new Date();
    const appointmentData = appt.startDateTime ? moment(appt.startDateTime) : moment(appt.date);
    const hoursDifference = appointmentData.diff(currentDateTime, 'hours')

    if (hoursDifference <= 24) {
      this.utils.showMessageSnackBar(`You can not ${event} appointment before 24 hours.`, true);
      return false;
    }
    return true;
  }

  cancelAppointment() {
    if (!this.appt) {
      this.utils.showMessageSnackBar('Appointment can not be cancelled.', true);
    }
    const apptCancelObj = {
      "appointmentId": this.appt.id,
      "status": AppointmentStatus.APPOINTMENT_CANCELLED
    };

    this.loaderService.blockWithLoader(this.appointmentService.updateAppointmentStatus(apptCancelObj)).subscribe(
      (res) => {
        if (res.response.isSuccess) {
          this.getAppointmentsByPatientId(this.patientProfile.id);
          this.utils.showMessageSnackBar(`Appointment with Dr. ${this.appt.practitioner.fullName} has been cancelled successfully.`);
        }
        else {
        }
      },
      (error) => {
        this.utils.showMessageSnackBar(error, true);
        console.error(error);
      }
    );
  }

  rescheduleAppointment(appt: Appointment) {
    this.appt = appt;
    const isRescheduleAllowed = this.IsCancelOrRescheduleAllow(appt, 'reschedule');
    if (!isRescheduleAllowed) {
      return;
    }
    let dialogRef = this.dialog.open(RescheduleAppointmentComponent, {
      width: '840px',
      disableClose: true,
      data: {
        appt: appt
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      this.getAppointmentsByPatientId(this.patientProfile.id);
      if (result.success) {
        this.utils.showMessageSnackBar(`Appointment request sent to Dr. ${this.appt.practitioner.fullName}!`);
      }
    });
  }

  getProviderServiceCost() {

    //const zipCode = this.appt.practitioner && this.appt.practitioner.location ? this.appt.practitioner.location.zipCode : "";
    let zipCode = this.patientProfile.addresses.find(x => x.type == 'HOME');
    if (!zipCode) {
      zipCode = this.patientProfile.addresses.find(x => x.zipCode != null);
    }
    const planid = this.patientProfile.patientInsurances.find(x => x.insuranceType == "Primary" && x.insurancePlanPayerId != null);

    const providerCostEstimatorRequestObj: ProviderCostEstimator = {
      search_parameters: {
        npi_numbers: {
          professional_npi_numbers: [this.appt.practitioner.npi ? +this.appt.practitioner.npi : 0]
        },
        location: {
          zip_code: zipCode ? zipCode.zipCode : "",// "75202", // Zip code for patient
          radius_in_miles: 50 //Hard coded
        }
      },
      plan_details: {
        plan_id: planid.insurancePlanPayerId ? planid.insurancePlanPayerId : "",  // Insurance Plan table PayerId
        plan_id_type: "EIN",  // Hard coded
        plan_name: planid.insurancePlanName ? planid.insurancePlanName : ""//"NATIONAL-PPO" // Insurance Plan table name column
      },
      "service_details": [
        {
          billing_code_type: "CPT", // Hard coded
          billing_code: this.treatmentCode ? this.treatmentCode : "" // Service Code is Treatment table code column.
        }
      ]
    };

    this.loaderService.blockWithLoader(this.appointmentService.getProviderCostEstimation(providerCostEstimatorRequestObj)).subscribe(
      (res) => {
        if (res && res.estimates && res.estimates.length > 0 && res.estimates[0].total_combined_cost!=undefined) {
          this.providerPricing = res.estimates[0].total_combined_cost.total_cost != undefined ? res.estimates[0].total_combined_cost.total_cost.human_readable:"$0";
        }
        else if (res.estimates[0].institutional_info.institutional_fee.total_cost.human_readable != undefined && res.estimates[0].institutional_info.institutional_fee.total_cost.human_readable != null) {
          this.providerPricing = res.estimates[0].institutional_info.institutional_fee.total_cost.human_readable;
        }
        else {
          this.providerPricing = "$0.00";
        }
      },
      (error) => {
        this.loaderService.hide();
        this.providerPricing = "$0.00";
        this.utils.showMessageSnackBar(error.error.error, true);
        console.error(error);
      }
    );
  }

  getTreatmentsByName(): void {
    this.loaderService.show();
    this.practiceService.getTreatmentsByName(this.appt.treatment).subscribe(
      (symp) => {
        this.loaderService.hide();
        if (symp) {
          if (symp.length > 0) {
            if (symp[0]) {
              this.treatmentCode = symp[0].code ? symp[0].code : "";
              this.getProviderServiceCost();
            }
          }

        }
      },
      (error) => { console.error(error); this.loaderService.hide(); },
    )
  }


}
